import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot
} from '@angular/router';
@Injectable()
export class RoleGuardService implements CanActivate {
    constructor(public router: Router) { }
    canActivate(route: ActivatedRouteSnapshot): boolean {
        let userDetails = localStorage.getItem('userDetails');
        if (userDetails) {
            let userDetJson = JSON.parse(userDetails);
            let userRoleID = userDetJson.userRoleMappings[0].roleName;
            const token = userRoleID;
            let dataSet = route.data
            let dataSetArray = [];
            for (let key in dataSet) {
                dataSetArray.push(dataSet[key])
            }
            let isRoleActive = false;
            for (let i = 0; i < dataSetArray.length; i++) {
                const element = dataSetArray[i];
                if (dataSetArray[i] == token) {
                    isRoleActive = true
                }
            }
            if (!isRoleActive) {
                this.router.navigate(['accessDenied']);
                return false;
            }
            return true;
        }

    }
}